import React, { Component } from 'react'
import Colors from '../../../themes/Colors'
import SectionHeading from '../common/SectionHeading'
import PartnersSection from './PartnersSection'
import StatList from './StatsSection/StatList'
import TestimonialSlick from './TestimonialSlick'

import {
  IbCricketAtIplSection,
  Container,
  PartnersStatsContainer
} from './styledComponents'

class IbCricketAtIpl2019 extends Component {
  render() {
    const { iBCricketAtIplSectionData, id } = this.props
    const {
      title,
      statsList,
      partnersList,
      testimonialsList
    } = iBCricketAtIplSectionData
    return (
      <IbCricketAtIplSection id={id}>
        <Container>
          <SectionHeading
            sectionHeadingText={title}
            color={Colors.pumpkinOrange}
          />
          <PartnersStatsContainer>
            <StatList statsList={statsList} />
            <PartnersSection partnersList={partnersList} />
          </PartnersStatsContainer>
          <TestimonialSlick testimonialsList={testimonialsList} />
        </Container>
      </IbCricketAtIplSection>
    )
  }
}

export default IbCricketAtIpl2019



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/IbCricketAtIpl2019/index.js